import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/functions'
import 'firebase/storage'

import axios from 'axios'

var config = {
  /* LIVE */
  apiKey: 'AIzaSyAPVbzWgErmL4y6vbc2174IUwL8XUrd-0k',
  authDomain: 'cap-prize.firebaseapp.com',
  databaseURL: 'https://cap-prize.firebaseio.com',
  projectId: 'cap-prize',
  storageBucket: 'cap-prize.appspot.com',
  messagingSenderId: '149491699235'

  /* TEST 
  apiKey: 'AIzaSyB9Cnb4p8qYURury3-eDGKEtUokjX4gOF8',
  authDomain: 'crud-cap.firebaseapp.com',
  databaseURL: 'https://crud-cap.firebaseio.com',
  projectId: 'crud-cap',
  storageBucket: 'crud-cap.appspot.com',
  messagingSenderId: '216017999876'
  */
}

var apiClient = axios.create({
  // LIVE
  baseURL: 'https://us-central1-cap-prize.cloudfunctions.net',
  // TESTING
  // baseURL: 'http://localhost:5001/cap-prize/us-central1',
  headers: { 'Content-Type': 'application/json' }
})

firebase.initializeApp(config)

const db = firebase.firestore()
const auth = firebase.auth()
const storageRef = firebase.storage().ref()

db.settings({
  timestampsInSnapshots: true
})

export default {
  db,
  auth,
  storageRef,
  /* -------------------------------------------------------------------------- */
  // SHORTLIST
  readScoredEntries() {
    return firebase
      .firestore()
      .collection('forReview')
      .get()
      .then(querySnapShot => {
        var docs = {}
        querySnapShot.forEach(doc => {
          let objDoc = { [doc.id]: doc.data() }
          let scoresArray = Object.values(doc.data().scores)
          let total = Number(0)
          scoresArray.forEach(score => {
            if (score.total > -1) {
              total = total + Number(score.total)
            }
          })
          objDoc[doc.id].total = total
          docs = Object.assign(objDoc, docs)
        })
        return docs
      })
  },
  /* -------------------------------------------------------------------------- */
  // JUDGING
  readEntriesForReview(judgeID) {
    // console.log('readEntriesForReview')
    // console.log(judgeID)
    return firebase
      .firestore()
      .collection('forReview')
      .orderBy('scores.' + judgeID + '.total', 'asc')
      .orderBy('name', 'desc')
      .get()
      .then(querySnapShot => {
        var docs = {}
        querySnapShot.forEach(doc => {
          let objDoc = { [doc.id]: doc.data() }
          docs = Object.assign(objDoc, docs)
        })

        // console.log(docs)
        return docs
      })
  },

  readEntriesForReviewButton(judgeID) {
    // console.log('readEntriesForReview')
    // console.log(judgeID)
    return firebase
      .firestore()
      .collection('forReview')
      .orderBy('scores.' + judgeID + '.total', 'asc')
      .orderBy('name', 'desc')
      .get()
      .then(querySnapShot => {
        var docs = {}
        querySnapShot.forEach(doc => {
          let objDoc = { [doc.id]: doc.data() }
          docs = Object.assign(objDoc, docs)
        })

        // console.log(docs)
        return docs
      })
  },

  updateScore(judgeID, scoreOb, entryID) {
    // console.log('doc: ' + entryID)
    const FBdocument = `forReview/${entryID}`
    var currentDocument = firebase.firestore().doc(FBdocument)
    return currentDocument.update({
      ['scores.' + judgeID]: scoreOb
    })
  },

  readSeenUnseenEntriesForReview(judgeID, condition) {
    // console.log('readCompletedFilteredEntries: ' + key)
    return firebase
      .firestore()
      .collection('readEntriesForReview')
      .where('scores.' + judgeID + '.viewed', '==', condition)
      .orderBy('scores.' + judgeID + '.total', 'desc')
      .orderBy('name', 'desc')
      .get()
      .then(querySnapShot => {
        var docs = {}
        querySnapShot.forEach(doc => {
          let objDoc = { [doc.id]: doc.data() }
          docs = Object.assign(objDoc, docs)
        })
        return docs
      })
  },

  /* -------------------------------------------------------------------------- */
  // COMPLETED ENTRIES

  readCompletedEntries() {
    return firebase
      .firestore()
      .collection('completedEntries')
      .orderBy('name', 'desc')
      .get()
      .then(querySnapShot => {
        var docs = {}
        querySnapShot.forEach(doc => {
          let objDoc = { [doc.id]: doc.data() }
          docs = Object.assign(objDoc, docs)
        })
        return docs
      })
  },
  readCompletedFilteredEntries(key) {
    // console.log('readCompletedFilteredEntries: ' + key)
    return firebase
      .firestore()
      .collection('completedEntries')
      .where(key, '==', true)
      .orderBy('name', 'desc')
      .get()
      .then(querySnapShot => {
        var docs = {}
        querySnapShot.forEach(doc => {
          let objDoc = { [doc.id]: doc.data() }
          docs = Object.assign(objDoc, docs)
        })
        return docs
      })
  },
  getComment() {
    return firebase
      .firestore()
      .collection('completedEntries')
      .where('comment.length', '>', 0)
      .orderBy('comment.length', 'desc')
      .orderBy('name', 'desc')
      .get()
      .then(querySnapShot => {
        var docs = {}
        querySnapShot.forEach(doc => {
          let objDoc = { [doc.id]: doc.data() }
          docs = Object.assign(objDoc, docs)
        })
        return docs
      })
  },
  getNotReviewed() {
    // console.log('firebaseSrv')
    return firebase
      .firestore()
      .collection('completedEntries')
      .where('review', '==', false)
      .orderBy('name', 'desc')
      .get()
      .then(querySnapShot => {
        var docs = {}
        querySnapShot.forEach(doc => {
          let objDoc = { [doc.id]: doc.data() }
          docs = Object.assign(objDoc, docs)
        })
        return docs
      })
  },
  completedEntryUpdate(key, value, entry) {
    // console.log('doc: ' + entry)
    const FBdocument = `completedEntries/${entry}`
    var currentDocument = firebase.firestore().doc(FBdocument)
    return currentDocument.update({
      [key]: value
    })
  },

  /* -------------------------------------------------------------------------- */
  // USERS
  readUsers() {
    return firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(function(idToken) {
        return apiClient.get(`/adminListUsers?auth=${idToken}`)
      })

    // let idToken = 'sometoken'
    // return apiClient.get(`/adminListUsers?auth=${idToken}`)
  },
  readEntrants() {
    return firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(function(idToken) {
        return apiClient.get(`/adminListEntrys?auth=${idToken}`)
      })

    // let idToken = 'sometoken'
    // return apiClient.get(`/adminListUsers?auth=${idToken}`)
  },

  // ENTRY
  readAll() {
    return firebase
      .firestore()
      .collection('users')
      .get()
  },
  readUser(user = auth.currentUser.uid) {
    // const user = auth.currentUser.uid
    const FBdocument = `users/${user}`
    return firebase
      .firestore()
      .doc(FBdocument)
      .get()
  },
  updateUser(data, user = auth.currentUser.uid) {
    // console.log(JSON.stringify(data))
    // console.log('user: ' + user)
    const FBdocument = `users/${user}`
    var currentDocument = firebase.firestore().doc(FBdocument)
    return currentDocument.set(
      {
        user: { ...data }
      },
      { merge: true }
    )
  },
  deleteEntry(eid, user = auth.currentUser.uid) {
    // console.log('eid: ' + eid)
    // console.log('user: ' + this.user, 'current user: ' + auth.currentUser.uid)
    // const user = auth.currentUser.uid
    const FBdocument = `users/${user}`
    var currentDocument = firebase.firestore().doc(FBdocument)
    // console.log('deleteEntryID' + eid)
    return currentDocument.update({
      ['entries.' + eid]: firebase.firestore.FieldValue.delete()
    })
  },
  createEntry(data, user = auth.currentUser.uid) {
    // console.log(JSON.stringify(data))
    // const user = auth.currentUser.uid
    const FBdocument = `users/${user}`
    var currentDocument = firebase.firestore().doc(FBdocument)
    return currentDocument.set(
      {
        name: auth.currentUser.displayName,
        email: auth.currentUser.email,
        entries: data
      },
      { merge: true }
    )
  },
  updateEntry(data, user = auth.currentUser.uid) {
    // console.log('user: ' + user, 'current user: ' + auth.currentUser.uid)
    // const user = auth.currentUser.uid
    const FBdocument = `users/${user}`
    var currentDocument = firebase.firestore().doc(FBdocument)
    return currentDocument.update({
      ['entries.' + data.eid]: data
    })
  },
  finaliseEntry(eid, user = auth.currentUser.uid) {
    // const user = auth.currentUser.uid
    // console.log('finalise Entry user: ' + user)
    const FBdocument = `users/${user}`
    const timeStamp = firebase.firestore.Timestamp.now()
    // ('TimeStamp: ' + timeStamp)
    var currentDocument = firebase.firestore().doc(FBdocument)
    // console.log('currentDocument: ' + currentDocument)
    return currentDocument.update({
      ['entries.' + eid + '.dateFinalised']: timeStamp,
      ['entries.' + eid + '.complete']: true
    })
  },
  createPhoto(data, user = auth.currentUser.uid) {
    // console.log(JSON.stringify(data))
    // const user = auth.currentUser.uid
    const FBdocument = `users/${user}`
    var currentDocument = firebase.firestore().doc(FBdocument)
    return currentDocument.update({
      ['entries.' + data.eid + '.photos.' + data.pid]: data
    })
  },
  deletePhoto(data, user = auth.currentUser.uid) {
    // const user = auth.currentUser.uid
    const FBdocument = `users/${user}`
    // const photoKey = 'entries.' + data.eid + '.photos.' + data.pid
    // console.log('photokey: ' + photoKey)
    var currentDocument = firebase.firestore().doc(FBdocument)
    return currentDocument.update({
      ['entries.' +
      data.eid +
      '.photos.' +
      data.pid]: firebase.firestore.FieldValue.delete()
    })
  },
  getImage(path) {
    const storageRef = firebase.storage().ref()
    return storageRef.child(path).getDownloadURL()
  },
  addGalleryPathToPhoto(data) {
    const FBdocument = `users/${data.uid}`
    var currentDocument = firebase.firestore().doc(FBdocument)
    return currentDocument.update({
      ['entries.' +
      data.eid +
      '.photos.' +
      data.pid +
      '.galleryPath']: data.galleryPath
    })
  }
}

// push the new item, find the old item, remove the old item
